<!--
 * @Author: ldx
 * @Date: 2022-10-14 09:31:48
 * @LastEditors: ldx
 * @LastEditTime: 2023-12-19 18:19:33
 * @Description:  白板2软件-免责声明
-->
<template>
  <div style="padding: 10px 14px">
    <h3>{{ activationCompany.abbreviation }}帐号使用协议</h3>
    <p>
      在您开始注册或使用本平台之前，
      <strong>
        <u>请您务必认真阅读并充分理解本协议之全部条款（非完全民事行为能力人应在监护人陪同下阅读），特别是请重点注意免除或者减轻责任等与您有重大利害关系的条款。</u>
      </strong>
      请仔细阅读并接受或不接受本协议。如有任何问题，可向我们咨询。
    </p>
    <p><strong>1. 账号服务</strong></p>
    <p>
      <strong>
        <u>
          1.1 {{ activationCompany.abbreviation }}帐号的所有权归属于我们，我们亦有权根据本协议对{{
            activationCompany.abbreviation
          }}帐号进行合理的管理权利并提供帐号服务。您作为申请注册人，在本协议有效期内享有您所注册申请{{ activationCompany.abbreviation }}帐号的使用权。
        </u>
      </strong>
    </p>
    <p>
      1.2 当您注册或申请{{
        activationCompany.abbreviation
      }}帐号时，您需要提供您本人的手机号码进行注册和验证。除此外，您也可以自行选择提交帐号名称（昵称）、头像和简介等额外注册信息以获得更丰富的帐号体验，但您不提供该类额外注册信息并不会影响您使用基本的帐号功能服务。
    </p>
    <p><strong>2. 帐号使用规范</strong></p>
    <p>2.1 您保证合理地使用{{ activationCompany.abbreviation }}帐号，并接受本协议和遵守任何有效的法律法规。</p>
    <p>2.2 您应保证您有权或被授权传送、分发、公开、以及以任何可用的方式使用您{{ activationCompany.abbreviation }}帐户的名义进行的上传、下载、发布、传输、存储资料、内容。</p>
    <p>2.3 您可在本协议约定的范围内使用{{ activationCompany.abbreviation }}帐号，您不得利用{{ activationCompany.abbreviation }}帐号从事以下行为：</p>

    <p>（1）恶意注册帐号；</p>
    <p>（2）赠与、借用、租用、转让或售卖{{ activationCompany.abbreviation }}帐号或者以其他方式许可非初始申请注册人使用{{ activationCompany.abbreviation }}帐号；</p>
    <p>
      （3）利用{{
        activationCompany.abbreviation
      }}帐号发表、传送、传播、储存危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容或者设置含有上述内容的网名、角色名，发布、传送、传播广告信息、营销信息及垃圾信息等；
    </p>
    <p>（4）利用{{ activationCompany.abbreviation }}帐号侵害他人知识产权、肖像权、隐私权、名誉权等合法权利；</p>
    <p>（5）恶意虚构事实、隐瞒真相以误导、欺骗他人；</p>
    <p>
      （6）进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；
    </p>
    <p>（7）从事其他法律法规、政策及公序良俗、社会公德禁止的行为以及侵犯其他个人、公司、社会团体、组织的合法权益的行为。</p>

    <p><strong>3. 帐号注销</strong></p>
    <p>
      <strong>
        <u>
          3.1 我们为您提供帐号的注销服务。但我们在此善意地提醒您，帐号是您正常使用我们产品和服务的载体和条件，若您注销帐号，将导致您可能不能正常使用{{
            activationCompany.abbreviation
          }}校园管理平台，您所有使用该平台的数据将全部删除或匿名化，注销后，全部产品和服务均不可再继续正常使用，全部数据均将删除。
        </u>
      </strong>
    </p>
    <p>3.2 在您需要终止使用帐号服务时，符合以下条件的，您可以申请注销您的帐号。</p>
    <p>（1）您仅能申请注销您本人的帐号，并依照我们的流程进行注销；</p>
    <p>（2）您仍应对您在注销帐号前且使用我们服务期间的行为承担相应责任；</p>
    <p>（3）注销成功后，帐号信息、个人身份证信息、交易记录、会员权益等将无法恢复或提供。</p>
    <p>3.3 帐号一旦被注销将不可恢复，请您在操作之前自行备份帐号相关的所有信息和数据。</p>
    <p>
      3.4
      您可以通过在我们产品及服务的相关页面上找到注销的入口，按页面指引的方式进行操作（例如可能涉及身份的核验）。相关流程若需要人工参与的，则我们将在15个工作日内完成核查和处理。
    </p>
    <p><strong>4.违约责任</strong></p>

    <p>
      <strong>
        <u>
          4.1
          如果我们发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，我们有权对此独立进行判断，并有权采取警示、冻结、终止/中止/限制使用账号、删除信息内容等功能、中止使用许可或服务、解除或终止本协议，并提出损害赔偿（包括但不限于直接损失、间接损失、名誉损失、第三方罚款、索赔等）等措施。由此给您带来的损失（包括但不限于内容资料、数据清空等），由您自行承担。
        </u>
      </strong>
    </p>
    <p>4.2 若您违反本协议的约定而与第三方产生纠纷的或因使用第三方服务而产生纠纷的，一切后果需由您自行承担，与我们无关，我们无义务协助您处理此类纠纷。</p>
    <p><strong>5. 法律适用与管辖</strong></p>
    <p>5.1 本协议适用中华人民共和国法律。</p>
    <p>5.2 因本协议引起的或与本协议有关的任何争议，各方应友好协商解决；协商不成的，任何一方均可将有关争议提交至{{ activationCompany.company }}注册地所在法院管辖。</p>
    <p><strong>6. 其它事项</strong></p>

    <p>
      6.1
      再次提示，我们有权随时根据有关法律、法规的变化以及公司经营状况和经营策略的调整等修改本协议条款。修改后的服务条款将会在本平台网页或客户端、APP运行平台上公布。如果不同意修改的内容，您应停止使用该平台相关功能和技术服务。如果继续使用该等功能和技术服务，则视为您接受本协议条款的变动。
    </p>
    <p>
      6.2 本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，或违反任何适用的法律，则该条款被视为删除，但本协议的其余条款仍应有效并且有约束力。
      至此，用户已经详细阅读并已理解本协议，并同意严格遵守全部条款之约定。如果对本协议有任何疑问或者希望从我们获得任何信息，请按下列地址和方式与客服人员进行直接有效的对接联系，我们将在15个工作日内答复您。
    </p>

    <P>公司：{{ activationCompany.company }}</P>
    <P>电话：400-632-8880</P>
    <P>联系人：客服专员</P>
    <P>地址：{{ activationCompany.address }}</P>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: '东莞市安道光电材料制造有限公司',
        address: '广东省东莞市松山湖国际金融园C区11栋A座',
        abbreviation: '安道'
      }
    }
  },
  created() {
    this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
}
</style>
